import * as types from "../types";

const INITIAL_STATE = {
  user: "",
  showDetails: false,
  showPassChange: false,
  showOrdHistory: true,
  oldPass: "",
  newPass: "",
  confirmNewPass: "",
  curOrd:"",
  showOrderModal:false,
  orders: [],
  items: [],
  SubTot: 0,
  Disc: 0,
  Tax: 0,
  Net: 0,
  credit: 0,
  deliveryCharge: 0,
  orderNote: '',
  address: '',
  addressNote: '',
  phoneNumber: '',
  deliveryTimes:[],
  time:''
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.PROFILE_UPDATE_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
